import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { CommonProjectDataService } from "../../_services/common-project-data.service";
import { CommonService } from "../../_services/common.service";
import { Router } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl
} from "@angular/forms";

export interface DialogData {
  productFilters: {}
}

@Component({
  selector: 'app-own-garment',
  templateUrl: './own-garment.component.html',
  styleUrls: ['./own-garment.component.css']
})
export class OwnGarmentComponent implements OnInit {
  public loading = false;
  ownGarmentForm: FormGroup;
  public activeProjectIndex = "";
  public ownGarmentIndex = 0;
  public projects: any = {};
  public selectedProductId: string;
  //public ownGarmentsWeight = [];
  public ownGarmentsWeight = {};
  public ogColor: any = {};
  public orderStatus: string;
  public ownGarmentSizes = [];
  public isPublicQuoteCreation = false;
  constructor(public dialogRef: MatDialogRef<OwnGarmentComponent>,
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    private CommonProjectDataService: CommonProjectDataService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private router: Router

  ) {
    this.ownGarmentForm = this.formBuilder.group({
      brandName: [null, Validators.required],
      style: [null, Validators.required],
      colorName: [null, Validators.required],
      weight: [null, [Validators.required, Validators.min(0)]]
    });
    this.isPublicQuoteCreation = localStorage.getItem('isPublicQuoteCreation') === 'Yes' ? true : false;
  }

  ngOnInit() {
    this.activeProjectIndex = this.CommonProjectDataService.getActiveProjectIndex();
    this.orderStatus = this.CommonProjectDataService.getOrderType();
    this.projects = JSON.parse(JSON.stringify(this.CommonProjectDataService.get()));
    this.ownGarmentsWeight = JSON.parse(JSON.stringify(this.CommonProjectDataService.getOwnGarmentsWeight()));
    this.ogColor = { 'color_id': 'colorID-' + this.ownGarmentIndex, 'name': null, 'front_image': this.data.productFilters["default_style_image"], 'back_image': this.data.productFilters["default_style_image"] };
    this.getfilterList();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  isFieldValid(field: string) {
    return (
      !this.ownGarmentForm.get(field).valid &&
      this.ownGarmentForm.get(field).touched
    );
  }

  addOwnGarmentData(postData) {
    this.ownGarmentIndex = (!this.projects.projects_data[this.activeProjectIndex]['products']) ? 0 : this.projects.projects_data[this.activeProjectIndex]['products'].length;
    this.selectedProductId = 'own-garment-' + this.ownGarmentIndex;
    //ShareScope.store("selectedProductId", $scope.selectedProductId);
    this.ogColor["name"] = postData.colorName;
    let pdesc = {
      'product_id': 'own-garment-' + this.ownGarmentIndex,
      'name': postData.style,
      'brand': postData.brandName,
      'title': 'own-garment',
      'colors': this.ogColor,
      'weight': postData.weight,
      'type':'own-garment'
    };
    let tmpColor = this.ogColor;
    if (this.ownGarmentsWeight[this.activeProjectIndex]) {
      this.ownGarmentsWeight[this.activeProjectIndex]['own-garment-' + this.ownGarmentIndex] = postData.weight;
    }
    else {
      this.ownGarmentsWeight[this.activeProjectIndex] = { ['own-garment-' + this.ownGarmentIndex]: postData.weight };
    }


    //ShareScope.store('ownGarmentsWeight', $scope.ownGarmentsWeight);
    this.CommonProjectDataService.storeOwnGarmentsWeight(this.ownGarmentsWeight);
    const defineSizes = ["XS","S","M","L","XL","2XL","3XL","4XL","5XL","6XL"];
    let owngarmentSize = [];
    if(this.data.productFilters['own_garments_sizes']){
      owngarmentSize = this.data.productFilters['own_garments_sizes'].filter(x => x.type == 'ssactivewear' && defineSizes.includes(x.name));
    }
    else{
      owngarmentSize = this.ownGarmentSizes.filter(x => x.type == 'ssactivewear' && defineSizes.includes(x.name));
    }
    owngarmentSize.sort(function(a, b){
      return defineSizes.indexOf(a.name) - defineSizes.indexOf(b.name);
    });
    if (!this.projects.projects_data[this.activeProjectIndex]['products']) {
      this.projects.projects_data[this.activeProjectIndex]['products'] = [{
        'product_id': 'own-garment-' + this.ownGarmentIndex,
        'productDetail': pdesc,
        'style_image': this.data.productFilters['default_style_image'],
        'matrix': [{
          'color': tmpColor,
          'size': owngarmentSize,
          'quantity': new Array(owngarmentSize.length).fill(null),
          'verify_quantity': new Array(owngarmentSize.length).fill(null),
          'price': new Array(owngarmentSize.length).fill(null),
          'item_price': new Array(owngarmentSize.length).fill(null),
          'impression_price': new Array(owngarmentSize.length).fill(null),
          'total_price': new Array(owngarmentSize.length).fill(null),
          'set_total_price': new Array(owngarmentSize.length).fill(null),
        }]
      }]
      this.projects.projects_data[this.activeProjectIndex]['ownGarmentsWeight'] = this.ownGarmentsWeight[this.activeProjectIndex];

    }
    else {
      this.projects.projects_data[this.activeProjectIndex]['products'].push({
        'product_id': 'own-garment-' + this.ownGarmentIndex,
        'productDetail': pdesc,
        'style_image': this.data.productFilters['default_style_image'],
        'matrix': [{
          'color': tmpColor,
          'size': owngarmentSize,
          'quantity': new Array(owngarmentSize.length).fill(null),
          'verify_quantity': new Array(owngarmentSize.length).fill(null),
          'price': new Array(owngarmentSize.length).fill(null),
          'item_price': new Array(owngarmentSize.length).fill(null),
          'impression_price': new Array(owngarmentSize.length).fill(null),
          'total_price': new Array(owngarmentSize.length).fill(null),
          'set_total_price': new Array(owngarmentSize.length).fill(null),
        }]
      });
      this.projects.projects_data[this.activeProjectIndex]['ownGarmentsWeight'] = this.ownGarmentsWeight[this.activeProjectIndex];
    }
    this.CommonProjectDataService.store(this.projects);
    //ShareScope.store('PFprojects', $scope.projects);

    //var myEl = angular.element( document.querySelector( '.modal-overlay' ) );
    //myEl.remove();
    this.dialogRef.close();
    if (this.orderStatus == 'Quote') {
      if(this.isPublicQuoteCreation == true){
        this.router.navigate(["/builder/quote/product-quantity"]); 
      }
      else{
        this.router.navigate(["/quote/product-quantity"]); 
      }
    }
    else {
      this.router.navigate(["/invoices/product-quantity"]);
    }
    //$location.path("/pfquantity/");
  }

  getfilterList = function () {
    this.loading = true;
    this.options = {
      id: localStorage.getItem("userID")
    }
    this.commonService.apiService(
      "POST",
      "custom/filters",
      this.options
    ).subscribe(
      (response: any) => {
        if (response.status === true) {
          this.loading = false;
          if (response.data) {
            this.ownGarmentSizes = response.data.own_garments_sizes;
          }
        }
      },
      err => {
        this.loading = false;
        console.log(err);
      }
    );
  }
}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-invoices/own-garment/own-garment.component.ts